import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { FormGroup } from '@angular/forms';
import { RiderNotesInformationService } from '../../../../core/services/rider-notes-information.service';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { SweetAlertHelper } from '../../../../core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-rider-notes-information',
  templateUrl: './rider-notes.component.html',
  styleUrls: ['./rider-notes.component.scss']
})
export class RiderNotesComponent implements OnInit, OnDestroy {

  private titleNotes: string;
  private gridNotes: GridOptions;
  private gridData = [];
  private data = {};
  public suscriptions: Subscription[] = [];

  @Input() formNotes: FormGroup;
  @Input() riderId: number;
  @ViewChild('modalNote') modalNote: T2CardComponent;

  constructor(
    private _service: RiderNotesInformationService,
    private _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    ) {
    this.gridNotes = <GridOptions>{};
    this.gridNotes.columnDefs = this.createColumn();
  }

  ngOnInit() {
    this.getNotes();
    this.observables();
  }

  observables() {
    this.suscriptions.push(
      this._service.changeNotes$.subscribe({
        next: (resp: boolean) => {
          if (resp) {
            this.getNotes();
          }
        },
      })
    );
  }

  /**
   * @description trae las notas del rider
   */
  getNotes() {
    this._loading.show();
      this._service.get(this.riderId)
        .finally(() => { this._loading.hiden(); })
        .subscribe(success => {
        this.gridData = success;
      });
  }

  /**
   * @name openModal
   * @description crea titulo y abre la modal
   * @param event = datos de la nota
   */
  openModal(event?): void {
    if (event) {
      this.titleNotes = `Edit Note: ${event.data.note.noteid}`;
    }else {this.titleNotes = `New note`; }
    this.modalNote.open();
  }

  /**
   * @description para click en grilla abre modal y pasa data de la grilla
   * @param event = datos de la nota
   */
  clickNotes(event): void {
    this.data = event.data;
    this.openModal(event);
  }

  /**
   * @description para cuando se cierra la modal
   */
  emitModalVisible(event): void {
    if (!event.isOpen) {
     this.deleteData();
    }
  }


  /**
   * @description para crear nueva nota
   */
  newNote() {
    this.deleteData();
    this.openModal();
  }

  /**
   * @description cierra la modal - close the modal
   * @param close = cerrar modal
   */
  closeModal(close: boolean): void {
    if (close) {this.modalNote.close(); }
  }

  /**
   * @description define mensaje y acción - define message and action
   * @param event = datos recibidos
   */
  savedSuccessfully(event): void {
    if (event.success) {
      this.closeModal(true);
      this.messageNotes(event.message, 'success');
      this.getNotes();
    }else {this.messageNotes('error while avoiding verify data', 'error'); }
  }

  /**
   * @description borra los datos del Objeto data si tiene
   */
  deleteData(): void {
    if (Object.getOwnPropertyNames(this.data).length) {this.data = {}; }
  }

  /**
   * @description borra nota del rider
   */
  deletNote() {
    if (this.gridNotes.api.getSelectedRows().length) {
      const id = this.gridNotes.api.getSelectedRows()[0].note.noteid;
      this.messageNotes(`are you sure to delete note: ${id}`, 'warning', true)
        .then( val => {
        if (val.value) {
          this._service.delete(id).subscribe(
            success => {this.messageNotes(success.message, 'success'); this.getNotes(); },
            error => {this.messageNotes(error.message, 'error'); }
            );
        }
      });
    }else {
      this.messageNotes('select a note to delete', 'error');
    }
  }

  /**
   * @description retorna Swal para mensajes
   * @param text  = texto del mensaje
   * @param type  = tipo de mensaje
   * @param delet = si es eliminación
   */
  messageNotes(text: string, type: any, delet?: boolean) {
    if (delet) {
      return this.sweetAlertHelper.createCustomAlert({
        title: 'Rider Notes',
        html: `<b style="color: red">${text}</b>`,
        type: type,
        allowOutsideClick: false,
        showCancelButton: true,
        cancelButtonColor: 'red'
      });
    }else {
      return this.sweetAlertHelper.createCustomAlert({
        title: 'Rider Notes',
        text: text,
        type: type
      });
    }
  }


  createColumn() {
    return [
      {
        headerName: '',
        width: 30,
        checkboxSelection: true
      },
      {
        headerName: 'Note',
        field: 'note.noteid',
        colId: 'noteid',
        width: 70,
      },
      {
        headerName: 'Date',
        field: 'note.date',
        colId: 'date',
        width: 100,
      },
      {
        headerName: 'Time',
        field: 'note.time',
        colId: 'consecutive',
        width: 100
      },
      {
        headerName: 'Note',
        field: 'note.description',
        colId: 'note',
        width: 350,
        cellStyle: {
          'white-space': 'normal'
        }
      },
      {
        headerName: 'User',
        field: 'note.adminuser.fullname',
        colId: 'status',
        width: 120
      },
      {
        headerName: 'Type',
        field: 'note.noteregistertype.value',
        colId: 'status',
        width: 120
      }
    ];
  }

  get isInactive(): boolean {
    return this.formNotes.get('isinactive').value;
  }

  ngOnDestroy() {
    this.suscriptions.forEach((sub) => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-notes-information/rider-notes.component.ts